import { useState } from 'react'
import { useParams } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import spinner from '../assets/spinner2.gif';
import Header from './header';
import Slider from './Slider';
import Footer from './Footer';

export default function Swatch() {
    const params = useParams()
    const id = params.swatchId
    const collection = JSON.parse(localStorage.getItem("collection"));
    const clientName = localStorage.getItem("clientName");
    const length = collection.length;
    let swatch = collection.find(item => item.swatch_unique_code === id);
    let imageIndex = collection.findIndex(item => item.swatch_unique_code === id);
    const backQueryString = localStorage.getItem("backQueryString");
    // console.log(id, collection, imageIndex);
    const [isLoading, setIsLoading] = useState(true);
     
    const navigate = useNavigate()

    const prev = () => {
        setIsLoading(true);
        navigate("/swatch/detail/" + collection[imageIndex - 1].swatch_unique_code);
    }
    const next = () => {
        setIsLoading(true);
        navigate("/swatch/detail/" + collection[imageIndex + 1].swatch_unique_code);
    }

    return (
        <>
            <Header clientName={clientName}/>
            <div className='swatch-page-container'>
                <div className='swatch-page-wrapper'>
                    <div style={{ textAlign: "center" }} className='collection-code-container'>
                        <strong className='swatch-code'>Swatch Code: {id}</strong>
                    </div>
                    {isLoading &&
                        <div className="loading">
                            <img src={spinner} alt="Loading..." />
                        </div>
                    }
                    <Slider key={id} setIsLoading={setIsLoading} primary_image={swatch.primary_image} url={swatch} />
                </div>
                <Footer
                    isPrevEnable={(imageIndex !== 0)}
                    isNextEnablen={(imageIndex !== (length - 1))}
                    next={next}
                    prev={prev}
                    back={{
                        text: "GO TO COLLECTION",
                        action : () => navigate("/collection" + backQueryString)
                    }}
                />
            </div>
        </>
    )

}
